const palette = {
  white: '#ffffff',
  black: '#000000',

  antiFlashWhite: '#f0f0f0',
  antiFlashWhiteAlt: '#f1f6f8',
  blackOlive: '#3e3e3e',
  brightGray: '#efeff1',
  brightGrayAlt: '#eeeeee',
  bubbles: '#e3f5fd',
  carminePink: '#ec4645',
  cultured: '#f4f4f4',
  culturedAlt: '#f6f8f9',
  cyanCornflowerBlue: '#2495c8',
  dollarBill: '#80c46b',
  fireEngineRed: '#c62828',
  gainsboro: '#dadada',
  ghostWhite: '#f6fcfe',
  lavenderGray: '#c4c7ca',
  lightSilver: '#d4d9dd',
  outerSpaceCrayola: '#2e383d',
  pictonBlue: '#47bff0',
  prussianBlue: '#06364e',
  vampireBlack: '#0b0b0b',
  wageningenGreen: '#42a225',
  graniteGray: '#606a69',
  richBlack: '#083244',

  neutral100: '#1a1a1a',
  neutral200: '#262626',
  neutral300: '#333333',
  neutral400: '#4d4d4d',
  neutral500: '#7a7a7a',
  neutral600: '#b2b2b2',
  neutral700: '#e5e5e5',
  neutral800: '#f2f2f2',
  neutral900: '#f7f7f7',

  primary100: '#0b023b',
  primary200: '#2D1C82',
  primary300: '#0067D3',
  primary400: '#2196f3',
  primary500: '#007dff',

  success100: '#072c14',
  success200: '#0e5827',
  success300: '#16833b',
  success400: '#1daf4e',
  success500: '#24db62',
  success600: '#24db6299',
  success700: '#24db6254',
  success800: '#24db6233',
  success900: '#24db621a',

  warning100: '#2f2304',
  warning200: '#5f4607',
  warning300: '#8e6a0b',
  warning400: '#be8d0e',
  warning500: '#edb012',
  warning600: '#edb01299',
  warning700: '#edb01254',
  warning800: '#edb01233',
  warning900: '#edb0121a',

  danger100: '#2d0606',
  danger200: '#5b0b0b',
  danger300: '#881111',
  danger400: '#b61616',
  danger500: '#e31c1c',
  danger600: '#e31c1c99',
  danger700: '#e31c1c54',
  danger800: '#e31c1c33',
  danger900: '#e31c1c1a',

  info100: '#092a28',
  info200: '#125551',
  info300: '#1c7f79',
  info400: '#25aaa2',
  info500: '#2ed4ca',
  info600: '#2ed4ca99',
  info700: '#2ed4ca54',
  info800: '#2ed4ca33',
  info900: '#2ed4ca1a',
}

export default palette
